let channelNameToChannelId = {
	'C3M2': 1,
	'C4M1': 2,
	'F3M2': 3,
	'F4M1': 4,
	'O1M2': 5,
	'O2M1': 6,
	'E1M2': 7,
	'E2M2': 8,
	'EMGR': 9,
	'ECG': 10,
	'Sound': 11,
	'NPress': 12,
	'Therm': 13,
	'Thor': 14,
	'Abdo': 15,
	'SpO2': 16,
	'LimbL': 17,
	'LimbR': 18,
	'Pulse': 19,
	'Position': 20
}

export default channelNameToChannelId